import { css } from 'styled-components/macro';

export const metalFonts = css`
  font-family: 'Metal Mania', cursive;
  font-weight: 600;
  font-style: normal;
`;
